import { render, staticRenderFns } from "./FormAddRole.vue?vue&type=template&id=340777c7&scoped=true"
import script from "./FormAddRole.vue?vue&type=script&lang=js"
export * from "./FormAddRole.vue?vue&type=script&lang=js"
import style0 from "./FormAddRole.vue?vue&type=style&index=0&id=340777c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340777c7",
  null
  
)

export default component.exports